module.exports = __webpack_public_path__ + "img/vaidesn_md.c29d135c.jpg";